exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../node_modules/css-loader/index.js!normalize.css/normalize.css"), "");

// module
exports.push([module.id, "body{font-family:Roboto,sans-serif}h1{font-weight:300}b{font-weight:500}#content{margin:1ex}a{color:#00bcd4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/index.css
// module id = 228
// module chunks = 0